<app-item-base [open]="open">
  <p class="name" placement="right">
    送信元
  </p>
  <div class="edit-field">
    <input class="large-input" type="text" placeholder="sender@mail.com" [(ngModel)]="this.searchParams.mail_from"
      name="mail_from" />
  </div>
</app-item-base>